module.exports = __webpack_public_path__ + "img/stop-b.51eaac3d.png";